import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { useRef } from 'react';
import SignaturePad from 'react-signature-canvas';
import { Save01 } from 'untitledui-js-base';

interface SignatureDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (signature: string) => void;
  loading?: boolean;
  extra?: React.ReactNode;
}

export const SignatureDialog = ({ open, onClose, onSave, loading, extra }: SignatureDialogProps) => {
  const sigCanvas = useRef<SignaturePad>(null);

  const clear = () => sigCanvas.current?.clear();

  const save = () => {
    if (sigCanvas.current?.isEmpty()) {
      alert('Podepište se prosím.');
      return;
    }
    const signature = sigCanvas?.current?.getCanvas().toDataURL('image/png');
    onSave(signature ?? '');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Podpis dokumentu</DialogTitle>
      <DialogContent>
        {extra}
        {extra && (
          <Typography fontWeight="bold" mb={1}>
            Podpis
          </Typography>
        )}
        <SignaturePad
          ref={sigCanvas}
          canvasProps={{
            style: {
              width: '100%',
              height: '300px',
              border: '1px solid #ccc',
              borderRadius: '8px'
            }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ paddingBottom: 4 }}>
        <Button onClick={clear}>Vymazat</Button>
        <Button onClick={onClose}>Zrušit</Button>
        <Button
          variant="contained"
          onClick={save}
          color="success"
          startIcon={<Save01 size="20px" />}
          size="large"
          loading={loading}
        >
          Uložit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
